interface ILabelValueItem {
  label?: unknown;
  value?: unknown;
}

const hasVisibleText = (input: unknown): boolean => {
  if (input === undefined || input === null) return false;
  const text = String(input)
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;|&#160;/gi, " ")
    .replace(/[\s ​]+/g, "");
  return text.length > 0;
};

/**
 * Drops list items that would render as empty cards: null/undefined entries and
 * items whose label AND value both have no visible text. Items with only one
 * side filled are kept. Order is preserved.
 */
export const filterBlankItems = <T extends ILabelValueItem>(
  items: (T | null | undefined)[] | null | undefined
): T[] =>
  (items || []).filter(
    (item): item is T =>
      !!item && (hasVisibleText(item.label) || hasVisibleText(item.value))
  );
